import moment, { Moment } from "moment-timezone"
import { useSettingsQuery } from "./use-settings-query"

const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY'
const DEFAULT_TIME_FORMAT_KEY: '12h' | '24h' = '12h'

export const useSettingsDateFormat = () => {

  const { defaultTimeFormat } = useDefaultTimeFormat()
  const { defaultDateFormat } = useDefaultDateFormat()

  const dateToDateString = (date: Moment | string) => {
    return moment(date).format(defaultDateFormat)
  }

  const dateToTimeString = (date: Moment | string) => {
    return moment(date).format(defaultTimeFormat)
  }

  const dateToDateTimeString = (date: Moment | string) => {
    return `${dateToDateString(date)} ${dateToTimeString(date)}`
  }

  return {
    dateToDateString,
    dateToTimeString,
    dateToDateTimeString,
  }
}

const useDefaultTimeFormat = () => {
  const { settingsQuery } = useSettingsQuery()

  if (settingsQuery.data) {
    const settings = settingsQuery.data.settings
    const timeFormat = settings.timeFormat

    return {
      defaultTimeFormat: timeFormat == '24h' ? 'HH:mm' : 'h:mm A',
      defaultTimeFormatKey: timeFormat,
      loaded: true,
    }
  } else {
    return {
      defaultTimeFormat: 'HH:mm',
      defaultTimeFormatKey: DEFAULT_TIME_FORMAT_KEY,
      loaded: false
    }
  }
}

const useDefaultDateFormat = () => {
  const { settingsQuery } = useSettingsQuery()

  if (settingsQuery.data) {
    return {
      defaultDateFormat: settingsQuery.data.settings.dateFormat || DEFAULT_DATE_FORMAT,
      loaded: true,
    }
  } else {
    return {
      defaultDateFormat: DEFAULT_DATE_FORMAT,
      loaded: false
    }
  }
}